import { api, throwApiError } from "../../../api/api";

export type ProductReference = {
  id: string;
  numeroItem: string;
  descricao: string;
  productId: string;
  packSize: number;
  baseProductId?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PaginatedProductReferencesResponse = {
  data: ProductReference[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
};

export type CreateProductReferenceDto = {
  numeroItem: string;
  descricao: string;
  productId: string;
  packSize?: number;
  baseProductId?: string | null;
};

export type UpdateProductReferenceDto = {
  numeroItem?: string;
  descricao?: string;
  productId?: string;
  packSize?: number;
  baseProductId?: string | null;
};

export const getProductReferencesApi = async (
  token: string,
  params: { query?: string; page?: number; limit?: number } = {}
): Promise<PaginatedProductReferencesResponse> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  try {
    const { data } = await api.get<PaginatedProductReferencesResponse>("/product-reference", {
      params,
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar referências De/Para.");
    throw error;
  }
};

export const getProductReferenceByIdApi = async (
  token: string,
  id: string
): Promise<ProductReference> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  try {
    const { data } = await api.get<ProductReference>(`/product-reference/${id}`, {
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar referência De/Para.");
    throw error;
  }
};

export const createProductReferenceApi = async (
  token: string,
  dto: CreateProductReferenceDto
): Promise<ProductReference> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  try {
    const { data } = await api.post<ProductReference>("/product-reference", dto, {
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao criar referência De/Para.");
    throw error;
  }
};

export const updateProductReferenceApi = async (
  token: string,
  id: string,
  dto: UpdateProductReferenceDto
): Promise<ProductReference> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  try {
    const { data } = await api.patch<ProductReference>(`/product-reference/${id}`, dto, {
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao atualizar referência De/Para.");
    throw error;
  }
};

export const deleteProductReferenceApi = async (
  token: string,
  id: string
): Promise<{ message: string }> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  try {
    const { data } = await api.delete<{ message: string }>(`/product-reference/${id}`, {
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao remover referência De/Para.");
    throw error;
  }
};

export const uploadProductReferencesExcelApi = async (
  token: string,
  file: File
): Promise<{ created: number; updated: number; total: number }> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;
  const formData = new FormData();
  formData.append("file", file);
  try {
    const { data } = await api.post<{ created: number; updated: number; total: number }>(
      "/product-reference/upload",
      formData,
      {
        headers: {
          Authorization: `Bearer ${rawToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro no upload do arquivo De/Para.");
    throw error;
  }
};
